import React from "react";
import { createRoot } from "react-dom/client";
import HelpSelectorIsland from "./HelpSelectorIsland";

const mountNode = document.getElementById("help-selector-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<HelpSelectorIsland config={config} />);
  }
}
